import { Tag } from 'antd';

// Configuración de colores para Status
export const statusStyles: Record<string, { color: string, label: string }> = {
  processing: { color: 'blue', label: 'Procesando' },
  awaiting: { color: 'warning', label: 'Esperando' },
  verifying: { color: 'purple', label: 'Verificando' },
  'in progress': { color: 'cyan', label: 'En Progreso' },
  sent: { color: 'geekblue', label: 'Enviado' },
  completed: { color: 'success', label: 'Completado' },
  canceled: { color: 'error', label: 'Cancelado' },
  saved: { color: 'default', label: 'Guardado' },
};

// Configuración para Métodos de Pago
export const paymentStyles: Record<string, string> = {
  paypal: '#003087',
  binance: '#F3BA2F',
  zelle: '#6d1ed1',
  'pago movil': '#ff4d4f',
  divisas: '#52c41a',
};

// Configuración para Entrega
export const addressStyles: Record<string, string> = {
  delivery: 'orange',
  pickup: 'green',
  envio: 'volcano',
};